<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="'resultadoModal' + name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog2 modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Resultados</h5>
                            <button type="button" class="close" @click="fechar()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados || !dados.length" />

                        <div v-else-if="graph_resultado" style="max-width: 1000px; max-height: 80vh;">

                            <Chart 
                                v-if="graphData"
                                type="line" 
                                :data="graphData"
                                :options="options"  />

                            <button type="button" class="btn btn-secondary mt-3" @click="graph_resultado = null">Voltar para Tabela</button>
                            
                        </div>

                        <div v-else>
                            <az-input
                                :placeholder="search_type == 'D' ? 'Destacar...' : 'Pesquisar...'"
                                v-model="search">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fa fa-search" aria-hidden="true" v-if="search_type == 'P'"></i>
                                            <i class="fas fa-highlighter" aria-hidden="true" v-if="search_type == 'D'"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" @click.prevent="search_type = 'P'">
                                                <i class="fa fa-search mr-2" aria-hidden="true"></i>
                                                Pesquisar
                                            </a>
                                            <a class="dropdown-item" href="#" @click.prevent="search_type = 'D'">
                                                <i class="fas fa-highlighter mr-2"></i>
                                                Destacar
                                            </a>
                                        </div>
                                    </div>
                                </template>
                            </az-input>

                            <div class="mb-3">
                                <a href="#" class="text-white" @click.prevent="search = toggle_search(search, tag)" v-for="(tag, itx) in hashtags_lancadas" :key="itx">
                                    <span class="badge badge-dark mr-1 mb-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </div>

                            <table class="table table-hover table-sm cabecalho-fixo-modal">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th v-for="(data, idx) in datas" :key="idx">
                                            <div>{{ $util.getFormatDate(data.dt_resultado) }}</div>
                                            <small class="text-muted">{{ diff_human(data.dt_resultado) }}</small>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(resultados_da_data, titulo, irx) in resultados" :key="irx">
                                        <td class="small">
                                            <a href="#" class="card-link" v-if="resultados_da_data.length > 1" @click.prevent="graph_resultado = titulo">
                                                {{ titulo }}
                                            </a>
                                            <span v-else>
                                                {{ titulo }}
                                            </span>
                                        </td>
                                        <td v-for="(data, idx) in datas" :key="idx" 
                                            :class="( search && search_type == 'D' && getValorData(resultados_da_data, data.dt_resultado) && getValorData(resultados_da_data, data.dt_resultado).destaque ) ? 'table-warning' : ''">
                                            <template v-if="getValorData(resultados_da_data, data.dt_resultado)">
                                                <a href="#" class="card-link" @click.prevent="exibir_valor_ref(resultados_da_data, data.dt_resultado)">
                                                    <span :class="getColorData(resultados_da_data, data.dt_resultado)">  
                                                        {{ getValorData(resultados_da_data, data.dt_resultado).st_valor }}
                                                    </span>    
                                                </a>
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <pre v-if="1 == 0">{{ resultados }}</pre>

                        </div>
                    </div>
                    <div class="modal-footer d-flex- justify-content-between">
                        <div class="flex-grow-1">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fas fa-sort-alpha-down"></i>
                                        </span>
                                    </div>
                                </div>
                                <input v-model="ordemitems" type="text" class="form-control" placeholder="Lista de itens separadas por vírgula para ordenação...">
                            </div>
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary mr-1" @click="ver_lateral()" v-if="!block && no_consultorio">
                                <i class="fas fa-arrow-circle-right"></i>
                            </button>
                            <button type="button" class="btn btn-secondary mr-1" @click="fechar()">Fechar</button>
                            <button type="button" class="btn btn-outline-primary mr-1" @click="ver_internos()" v-if="!block">Internos</button>
                            <button type="button" class="btn btn-primary" @click="editar()" v-if="!block">Editar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" :id="'editarResultadoModal' + name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edição de Resultados</h5>
                            <button type="button" class="close" @click="fechar()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    icon="fas fa-calendar-alt"
                                    type="date"
                                    v-model="ref_edicao" />
                            </div>
                            <div class="col col-12 col-md-9">
                                <az-input
                                    icon="fa fa-search"
                                    placeholder="Pesquisar..."
                                    v-model="search_edicao" />

                                <div class="mb-3">
                                    <a href="#" class="text-white" @click.prevent="search_edicao = toggle_search(search_edicao, tag)" v-for="(tag, itx) in hashtags_lancadas" :key="itx">
                                        <span class="badge badge-dark mr-1 mb-1">
                                            {{ tag }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="form-row" v-for="(item, idx) in lista_edicao" :key="idx">
                            <div class="col col-12 col-md-3">
                                <az-input 
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="item.dt_resultado"
                                    @input="ref_edicao = item.dt_resultado"
                                    >
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" @click="item.excluido = true">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input 
                                    placeholder="Descrição..."
                                    type="autocomplete"
                                    optionsMode="json"
                                    :optionsList="resultados_lancados"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    :optionsInitial="item.st_resultado"
                                    :optionsSync="false"
                                    :optionsExternal="true"
                                    :optionsAddExternalOnLoseFocus="true"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_resultado">
                                    <template v-slot:button-pos>
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-primary" type="button">
                                                <i class="far fa-comment"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input 
                                    :placeholder="item.fl_numerico ? 'Valor...' : 'Texto do Resultado...'"
                                    :type="item.fl_numerico ? 'number' : 'text'"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_valor">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-equals" v-if="item.fl_numerico"></i>
                                                <i class="fas fa-align-left" v-else></i>
                                            </button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" href="#" @click.prevent="item.fl_numerico = false"><i class="fas fa-align-left mr-2"></i> Texto</a>
                                                <a class="dropdown-item" href="#" @click.prevent="item.fl_numerico = true"><i class="fas fa-equals mr-2"></i>Número</a>
                                            </div>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4">
                                <multiselect
                                    :id="idx"
                                    v-model="item.js_hashtags"
                                    :options="hashtags"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    :close-on-select="false"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="input-group mb-3" v-if="false">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-primary" @click="incluir(novositems, true)">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                            <input v-model="novositems" type="text" class="form-control" placeholder="Descrição do item, ou lista de itens separadas por vírgula...">
                        </div>

                        <div class="mt-3">
                            <a href="#" @click.prevent="incluir(opcao.search)"
                                v-for="(opcao, iox) in lista_opcoes" :key="iox">
                                <span class="badge badge-dark mb-1 mr-1">{{ opcao.search }}</span>
                            </a>
                        </div>

                        <pre class="alert alert-primary" v-if="false">{{ lista_opcoes }}</pre>
                        
                        <div class="my-5">&nbsp;</div>

                        <pre v-if="1 == 0">{{ edicao }}</pre>
                        <pre v-if="1 == 0">{{ resultados_lancados }}</pre>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div class="flex-grow-1">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-primary" @click="incluir(novositems, true)">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                                <input v-model="novositems" type="text" class="form-control" placeholder="Descrição do item, ou lista de itens separadas por vírgula...">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-primary" @click="incluir('')">
                                        <i class="fas fa-plus mr-2"></i>
                                        1
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary mr-1" @click="fechar()">Fechar</button>
                            <az-submit @click="atualizar()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Barra histórico lateral -->
        <div class="sticky-sidebar-right bg-white w3-animate-right" style="width: 300px;" v-if="visualizcao_resultados_lateral">

            <az-loading msg="Carregando..." v-if="$store.state.loading && resultados_carregando" />

            <div class="px-2" v-else>
                <div>
                    <az-input
                        sizing="sm"
                        icon="fa fa-search"
                        placeholder="Pesquisar..."
                        v-model="search">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" title="Editar" @click="editar_tabela()">
                                    <i class="fas fa-pen"></i>
                                </button>
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" title="Ver tabela ampliada" @click="ver_tabela()">
                                    <i class="fas fa-table"></i>
                                </button>
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" title="Fechar barra lateral" @click="ver_lateral()">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>

                <az-empty-state 
                    v-if="!dados || !dados.length"
                    class="mt-3"
                    msg="Nenhum resultado identificado."
                    icon="fas fa-table" 
                    action="Incluir"
                    :method="editar_tabela" />

                <table class="table table-hover table-responsive table-sm table-bordered mt-3" v-else>
                    <thead>
                        <tr>
                            <th class="small">Descrição</th>
                            <th v-for="(data, idx) in datas" :key="idx">
                                <small class="text-muted text-nowrap">{{ $util.getFormatDate(data.dt_resultado) }}</small>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(resultados_da_data, titulo, irx) in resultados" :key="irx">
                            <td class="small">
                                <a href="#" class="card-link" v-if="resultados_da_data.length > 1" @click.prevent="graph_resultado = titulo; ver_tabela();">
                                    {{ titulo }}
                                </a>
                                <span v-else>
                                    {{ titulo }}
                                </span>
                            </td>
                            <td v-for="(data, idx) in datas" :key="idx" 
                                :class="( search && search_type == 'D' && getValorData(resultados_da_data, data.dt_resultado) && getValorData(resultados_da_data, data.dt_resultado).destaque ) ? 'table-warning' : ''">
                                <template v-if="getValorData(resultados_da_data, data.dt_resultado)">
                                    <a href="#" class="card-link" @click.prevent="exibir_valor_ref(resultados_da_data, data.dt_resultado)" v-if="getValorData(resultados_da_data, data.dt_resultado).st_ref_texto">
                                        <span :class="getColorData(resultados_da_data, data.dt_resultado)">  
                                            {{ getValorData(resultados_da_data, data.dt_resultado).st_valor }}
                                        </span>
                                    </a>
                                    <template v-else>
                                        <span :class="getColorData(resultados_da_data, data.dt_resultado)">  
                                            {{ getValorData(resultados_da_data, data.dt_resultado).st_valor }}
                                        </span>
                                    </template>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

        <!-- Valor de Referência Modal -->
        <div class="modal fade" id="valorItemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item_ref">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ item_ref.st_resultado }}</h5>
                        <button type="button" class="close" @click="fechar_ref()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex justify-content-between">
                            <div>
                                {{ $util.getFormatDate(item_ref.dt_resultado) }}
                                <div class="small text-muted">{{ diff_human(item_ref.dt_resultado) }}</div>
                            </div>
                            <template v-if="item_ref.st_metodo">
                                <div v-if="item_ref.st_metodo.indexOf(']') < 0">
                                    {{ item_ref.st_metodo }}
                                </div>
                                <div v-else>
                                    {{ item_ref.st_metodo.indexOf(']') }}
                                </div>
                            </template>
                        </div>

                        <hr>

                        <div>
                            <span class="display-4">
                                {{ item_ref.st_valor }}
                            </span>
                            <span class="small text-muted" v-if="item_ref.st_unidade && item_ref.dc_valor && item_ref.dc_valor > 0">
                                {{ item_ref.st_unidade }}
                            </span>
                        </div>

                        <div class="alert alert-secondary mt-3 mb-0">
                            <pre style="white-space: pre-wrap;">{{ item_ref.st_ref_texto }}</pre>
                        </div>

                        <div class="mt-3 small text-muted" style="white-space: pre-wrap;" v-if="item_ref.st_ref_notas">{{ item_ref.st_ref_notas }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_ref()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Laudos Por Data Modal -->
        <laudo-entrega-modal ref="laudo_entrega" v-if="!block" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzLoading from '../../util/AzLoading.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import Multiselect from 'vue-multiselect';
import LaudoEntregaModal from '../enfermagem/LaudoEntregaModal.vue';

export default {
    data() { 
        return {
            atendimento: null, 
            dados: null,
            edicao: [],
            validate: false, 
            hashtags: [
                "normal",
                "alterado",
            ],
            search: "", 
            search_type: "P",
            search_edicao: "", 

            novositems: this.$util.getCookie('pep-lista-resultados'), 
            ordemitems: this.$util.getCookie('pep-ordem-resultados'), 

            opcoes: null,

            graph_resultado: "", 

            basicData: {
				labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
				datasets: [
					{
						label: 'First Dataset',
						data: [65, 59, 80, 81, 56, 55, 40],
						fill: false,
						borderColor: '#42A5F5'
					},
				]
            },
            options: {
				responsive: true,
                hoverMode: 'index',
                cubicInterpolationMode: 'monotone',
            },

            ref_edicao: "", 
            block: false, 

            resultados_carregando: false, 

            visualizcao_resultados_lateral: false, 

            item_ref: null, 
        }
    },

    props: ['name'],

    components: { 
        AzInput,
        Multiselect,
        AzSubmit,
        AzEmptyState,
        AzLoading, 
        LaudoEntregaModal, 
    },
    
    computed: { 

        graphData: function () {
            if ( !this.graph_resultado || !this.dados )
                return null;

            let items = _.orderBy(
                this.dados.filter(item => item.st_resultado == this.graph_resultado),
                'dt_resultado'
            );

            if ( items.length <= 1 )
                return null;

            return {
                cubicInterpolationMode: 'monotone',
				labels: items.map(item => this.$util.getFormatDate(item.dt_resultado)),
				datasets: [
					{
                        cubicInterpolationMode: 'monotone', 
                        lineTension: 0,
						label: this.graph_resultado,
						data: items.map(item => parseFloat(item.st_valor)),
						fill: false,
						borderColor: '#42A5F5',
					},
                    /*
                    {
						label: 'Limite Inferior',
						data: items.map(item => parseFloat(item.dc_ref_min)),
						fill: false,
						borderColor: '#00FF00'
					},
                    {
						label: 'Limite Superior',
						data: items.map(item => parseFloat(item.dc_ref_max)),
						fill: false,
						borderColor: '#00FF00'
					},
                    */
				]
            }
        },

        datas: function () { 
            return _.orderBy(
                _.map(
                    _.uniqBy(this.dados, 'dt_resultado'),
                    item => _.pick(item, 'dt_resultado')
                ),
                'dt_resultado',
                'desc'
            );
        },

        resultados: function () { 
            let pesquisar = this.search.trim();
            let filtros = pesquisar.split(',').map(item => item.trim());

            let lista = this.dados && this.dados.length ? 
                this.dados.map(item => { 
                    item.dt_format = this.$util.getFormatDate(item.dt_resultado);
                    item.destaque = ( !this.search || filtros.find(filtro => { 
                        let parts = filtro.replace(' ','.*');
                        let match = parts;
                        let reg = new RegExp(match, 'i');
                        return reg.test(JSON.stringify(item));
                     }));
                    return item;
                })
                .filter (item => this.search_type == 'D' || item.destaque ) : [];

            let ordem = _.invert(
                this.ordemitems.split(',')
                    .map(item => item.trim())
            );

            lista.map(item => { 
                item.ordem = ordem[item.st_resultado] ? parseInt(ordem[item.st_resultado]) : 9999;
                return item;
            });

            return _.groupBy(
                    _.orderBy(lista, ['ordem', 'st_resultado']), 
                    'st_resultado'
                );
        },

        hashtags_lancadas: function () { 
            return _.uniq(
                _.flatten(
                    _.map(this.dados, item => { 
                        return item.js_hashtags ? item.js_hashtags : [];
                    })
                )
            ).sort();
        },

        resultados_lancados: function () { 
            if ( this.opcoes )
                return this.opcoes;

            return _.orderBy(
                _.uniqBy(
                    _.map(this.dados, item => { 
                        return { id: item.st_resultado, search: item.st_resultado };
                    }),
                    'search'
                ),
                'search'
            ).filter(item => item.search);
        },

        lista_opcoes: function () { 
            if ( !this.opcoes )
                return [];

            return this.opcoes.filter( item => item.count > 1 );

            /*
            return _.orderBy(
                this.opcoes.filter( item => item.count > 1 ), 
                'count', 
                'desc'
            );
            */
        },

        lista_edicao: function () { 
            if ( !this.edicao )
                return [];

            let pesquisar = this.search_edicao.trim();
            let filtros = pesquisar.split(',').map(item => item.trim());

            let lista = ( this.edicao && this.edicao.length ) ? 
                this.edicao.map(item => { 
                    item.dt_format = this.$util.getFormatDate(item.dt_resultado)
                    item.destaque = ( item.dt_resultado == this.ref_edicao ) && 
                        ( !this.search_edicao || filtros.find(filtro => { 
                            let parts = filtro.replace(' ','.*');
                            let match = parts;
                            let reg = new RegExp(match, 'i');
                            return reg.test(JSON.stringify(item));
                        }) )
                    return item;
                })
                .filter (item => item.destaque ) : [];

            return lista.filter(item => !item.excluido);
        },


        no_consultorio: function () { 
            return this.$route.path.substr(0,12) == '/consultorio'
        },

    },

    watch: { 
        ordemitems: function (newValue) { 
            this.$util.setCookie('pep-ordem-resultados', newValue, 365);
        },
    },

    methods: { 
        ver_internos () { 
            $('.modal').modal('hide');
            this.$refs.laudo_entrega.abrir(this.atendimento);
        },

        exibir_valor_ref (resultado_da_data, data) { 
            this.item_ref = _.cloneDeep(this.getValorData(resultado_da_data, data));

            $('#valorItemModal').modal('show');
        },

        editar_tabela() { 
            this.ver_lateral();
            this.editar();
        },

        ver_tabela() { 
            this.ver_lateral();

            $('.modal').modal('hide');
            $('#resultadoModal' + this.name).modal('show');
        },

        ver_lateral() { 
            if ( this.visualizcao_resultados_lateral ) { 
                this.visualizcao_resultados_lateral = false;
                this.$emit('direita', false);    
                return;
            }

            this.fechar();
            this.visualizcao_resultados_lateral = true;

            this.$emit('direita', true);
        },

        fechar_ref() { 
            $('#valorItemModal').modal('hide');
        },

        fechar() { 
            $('#resultadoModal' + this.name).modal('hide');
            $('#editarResultadoModal' + this.name).modal('hide');
        },

        diff_human(data) { 
            if ( data == this.$util.hoje() )
                return 'hoje';

            let end = moment().startOf('day');
            return moment.duration(moment(data, 'YYYY-MM-DD').diff(end)).humanize(true);
        },
        
        bloquear_alterar(item) { 
            return item.id_medico == this.$store.state.user.id_pessoa;
        },

        toggle_search(search, tag) { 
            if ( search == '"' + tag + '"' ) { 
                search = "";
            } else { 
                search = '"' + tag + '"';
            }

            return search;
        },

        getValorData(resultados_da_data, data) { 
            return resultados_da_data.find(item => item.dt_resultado == data);
        },

        getColorData(resultados_da_data, data) { 
            let item = this.getValorData(resultados_da_data, data);

            if ( !item || !item.js_hashtags ) { 
                return item.st_ref_texto ? 'text-primary' : 'text-dark';
            }
            
            if ( item.js_hashtags.findIndex(item => item == 'alterado') >= 0 ) 
                return 'text-danger';
            else if ( item.js_hashtags.findIndex(item => item == 'normal') >= 0 ) 
                return 'text-success';
                
            return item.st_ref_texto ? 'text-primary' : 'text-dark';
        },

        visuaizar(id_paciente) { 
            this.block = true;
            this.dados = null;
            this.$store.commit("loading", true);

            if ( this.visualizcao_resultados_lateral ) { 
                this.ver_lateral();
            }

            $('#resultadoModal' + this.name).modal('show');

            this.$util.loadItem(this, { 
                service: 'resultados',
                func: 'index',
                parms: { 
                    id_paciente: id_paciente,
                }
            })
            .then(res => { 
                this.dados = res;
            })
            .finally(() => { 
                this.$store.commit("loading", false);
            });
        },

        abrir(atendimento, lateral = false) { 
            this.atendimento = atendimento;
            
            if ( lateral ) { 

                if ( !this.visualizcao_resultados_lateral ) { 
                    this.ver_lateral();
                }

                if ( !this.dados ) { 
                    this.resultados_carregando = true;
                    this.$store.commit("loading", true);
                } else { 
                    return;
                }

            } else { 

                if ( this.visualizcao_resultados_lateral ) { 
                    this.ver_lateral();
                }

                this.dados = null;
                this.resultados_carregando = true;
                this.$store.commit("loading", true);
            
                $('#resultadoModal' + this.name).modal('show');

            }

            this.$util.loadItem(this, { 
                service: 'resultados',
                func: 'index',
                parms: { 
                    id_paciente: this.atendimento.id_paciente,
                }
            })
            .then(res => { 
                this.dados = res;
            })
            .finally(() => { 
                this.$store.commit("loading", false);
                this.resultados_carregando = false;
            })
        },

        incluir(texto = "", listados = false) { 
            if ( listados ) { 
                this.$util.setCookie('pep-lista-resultados', texto, 365);

                let lista = texto.split(',');

                let incluiu = false;

                lista.forEach(item => { 
                    if ( this.edicao && item.trim() && this.edicao.find(ed => ed.st_resultado == item.trim()
                        && ed.dt_resultado == this.ref_edicao) ) { 
                        return;
                    }

                    incluiu = true;

                    this.incluir(item.trim());
                });

                if ( !incluiu ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Nenhum item pra ser lançado.",
                        life: 3000
                    });
                }

                return;
            }

            this.edicao.push({
                id_resultado: null, 
                id_medico: this.atendimento.id_medico,
                id_paciente: this.atendimento.id_paciente,
                id_atendimento: this.atendimento.id_atendimento,
                dt_resultado: this.ref_edicao, 
                fl_numerico: true, 
                st_resultado: texto,
                st_valor: "",
                dc_valor: "", 
                st_observacoes: "", 
                js_hashtags: [],
                excluido: false, 
            });
        },

        editar() { 
            this.validate = false;
            this.edicao = _.cloneDeep(this.dados);

            this.ref_edicao = this.$util.hoje();
            this.search_edicao = "";

            this.$util.loadItem(this, { 
                service: 'resultados',
                func: 'opcoes',
            })
            .then(res => { 
                this.opcoes = res;

                if ( _.get(res, '0.novositems') ) { 
                    this.novositems = _.get(res, '0.novositems');
                }

                if ( _.get(res, '0.ordemitems') ) { 
                    this.ordemitems = _.get(res, '0.ordemitems');
                }
            });
            
            $('.modal').modal('hide');
            $('#editarResultadoModal' + this.name).modal('show');
        },

        addTag (newTag, id) {
            this.hashtags.push(newTag);

            if ( !this.dados[id].js_hashtags )
                this.dados[id].js_hashtags = [];

            this.dados[id].js_hashtags.push(newTag);
        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'resultados',
                func: 'store',
                dados: { 
                    resultados: this.edicao
                },
                modal: 'editarResultadoModal' + this.name,
                callback: () => { 
                    this.abrir(this.atendimento);
                }
            });

        }
        
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.sticky-sidebar-right {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>